import domready from 'domready';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { persistor, store } from './store';
import { SnackbarProvider } from 'notistack';
import debug from 'debug';
import Logger from './logger';
import { MediaSipProvider } from './contexts/MediaSipContext';

import './index.css';
import App from './components/App';
import LoadingView from './components/LoadingView';

import * as serviceWorker from './serviceWorker';
import SipCaller from './sipCaller';

if (process.env.NODE_ENV !== 'production') {
	debug.enable('sipcaller:*');
}

const logger = new Logger();

let sipCaller;

SipCaller.init({ store });

domready(() => {
	logger.debug('DOM ready');

	run();
});

function run() {
	sipCaller = new SipCaller();
	global.sipCaller = sipCaller;

	const container = document.getElementById('sipcaller');
	const root = createRoot(container);

	root.render(
		<React.StrictMode>
			<Provider store={store}>
				<PersistGate loading={<LoadingView />} persistor={persistor}>
					<MediaSipProvider sipCaller={sipCaller}>
						<SnackbarProvider
							maxSnack={3}
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'left',
							}}
							preventDuplicate
						>
							<App />
						</SnackbarProvider>
					</MediaSipProvider>
				</PersistGate>
			</Provider>
		</React.StrictMode>
	);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
